import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {
	CameraSnapShotsByTimeWithFiltersLazy
} from "@containers/cameras/snapshots/snapShotsByTime/CameraSnapShotsByTimeWithFilters.lazy";

const CameraSnapStopByTimePage = () => {
	
	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<CameraSnapShotsByTimeWithFiltersLazy/>
			</Suspense>
		</PageLayout>
	)
};

export default CameraSnapStopByTimePage;